// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner_spinner__2-ePR {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-top: 4px solid #333;
	border-radius: 50%;
	animation: spinner_spin__-16yV 0.8s linear infinite;
	margin: auto;
	padding: none;
}

@keyframes spinner_spin__-16yV {
	to {
		transform: rotate(360deg);
	}
}

.spinner_pageOverlay__IeO0C {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.7);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.spinner_spinnerContainer__LqM1g {
	display: flex;
	align-items: center;
	justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/loadingSpinner/spinner.module.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,0BAA0B;CAC1B,kBAAkB;CAClB,mDAAoC;CACpC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,0BAA0B;CAC1B,kCAAkC;CAClC,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB","sourcesContent":[".spinner {\r\n\tborder: 4px solid rgba(0, 0, 0, 0.1);\r\n\tborder-top: 4px solid #333;\r\n\tborder-radius: 50%;\r\n\tanimation: spin 0.8s linear infinite;\r\n\tmargin: auto;\r\n\tpadding: none;\r\n}\r\n\r\n@keyframes spin {\r\n\tto {\r\n\t\ttransform: rotate(360deg);\r\n\t}\r\n}\r\n\r\n.pageOverlay {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: rgba(255, 255, 255, 0.7);\r\n\tbackdrop-filter: blur(4px);\r\n\t-webkit-backdrop-filter: blur(4px);\r\n\tz-index: 9999;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.spinnerContainer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `spinner_spinner__2-ePR`,
	"spin": `spinner_spin__-16yV`,
	"pageOverlay": `spinner_pageOverlay__IeO0C`,
	"spinnerContainer": `spinner_spinnerContainer__LqM1g`
};
export default ___CSS_LOADER_EXPORT___;
